import { useSelectedEmployeeContext } from '~/components/SelectedEmployee';

import { UseSelectedEmployeeDetailsOutput } from './useSelectedEmployeeDetails';

export type UseSelectedEmployeeIdOutput = {
  selectedEmployeeId: number;
  isSelectedEmployeeLoggedInUser: boolean;
  selectedEmployeeDetails: UseSelectedEmployeeDetailsOutput;
};

export const useSelectedEmployeeId = (): UseSelectedEmployeeIdOutput => {
  const {
    selectedEmployeeId,
    isSelectedEmployeeLoggedInUser,
    selectedEmployeeDetails,
  } = useSelectedEmployeeContext();

  return {
    selectedEmployeeId,
    isSelectedEmployeeLoggedInUser,
    selectedEmployeeDetails,
  };
};
